var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_2617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 0.833252H4.16667C3.062 0.834575 2.00296 1.27399 1.22185 2.0551C0.440735 2.83622 0.00132321 3.89526 0 4.99992L0 14.9999C0.00132321 16.1046 0.440735 17.1636 1.22185 17.9447C2.00296 18.7258 3.062 19.1653 4.16667 19.1666H15.8333C16.938 19.1653 17.997 18.7258 18.7782 17.9447C19.5593 17.1636 19.9987 16.1046 20 14.9999V4.99992C19.9987 3.89526 19.5593 2.83622 18.7782 2.0551C17.997 1.27399 16.938 0.834575 15.8333 0.833252V0.833252ZM4.16667 2.49992H15.8333C16.3323 2.5009 16.8196 2.65118 17.2325 2.93142C17.6453 3.21166 17.9649 3.60904 18.15 4.07242L11.7683 10.4549C11.2987 10.9227 10.6628 11.1853 10 11.1853C9.33715 11.1853 8.70131 10.9227 8.23167 10.4549L1.85 4.07242C2.03512 3.60904 2.35468 3.21166 2.76754 2.93142C3.1804 2.65118 3.66768 2.5009 4.16667 2.49992V2.49992ZM15.8333 17.4999H4.16667C3.50363 17.4999 2.86774 17.2365 2.3989 16.7677C1.93006 16.2988 1.66667 15.663 1.66667 14.9999V6.24992L7.05333 11.6333C7.83552 12.4135 8.89521 12.8516 10 12.8516C11.1048 12.8516 12.1645 12.4135 12.9467 11.6333L18.3333 6.24992V14.9999C18.3333 15.663 18.0699 16.2988 17.6011 16.7677C17.1323 17.2365 16.4964 17.4999 15.8333 17.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_2617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.77d8b8caf57701eb0917f6796ae33bb7.svg";
export { ForwardRef as ReactComponent };